import './ActiveWidget.css';
import React from "react";
import clock from '../../assets/images/clock.png'
import StandupBlock from './subwidgets/StandupBlock.js'
import HealthBlock from './subwidgets/HealthBlock.js';
import TransitionBlock from './subwidgets/TransitionBlock.js';
import RelaxBlock from './subwidgets/RelaxBlock.js';
import EatBlock from './subwidgets/EatBlock.js';
import FocusBlock from './subwidgets/FocusBlock.js';
import InputBlock from './subwidgets/InputBlock.js';

function ActiveWidget(props) {

    const widgetMap = {
        "focus": <FocusBlock setActiveBlock={props.setActiveBlock} userProfile={props.userProfile} setUserProfile={props.setUserProfile} tasks={props.userProfile.tasks}/>,
        "fuel": <EatBlock subtype={props.activeBlock.subtype}/>,
        "fitness":  <HealthBlock/>,
        "plan": <StandupBlock tasks={props.tasks} setTasks={props.setTasks} userProfile={props.userProfile}/>,
        "transition": <TransitionBlock subtype={props.activeBlock.subtype} userProfile={props.userProfile}/>,
        "relax": <RelaxBlock type="unspecified"/>,
        "input": <InputBlock subtype={props.activeBlock.subtype}/>
    }
    return (
        <div className="activeWidgetDiv">
            <div className={"activeDivElement " + (!props.activeBlock.workingBlock.isGlowBlock ? " powerActiveWidget" : " glowActiveWidget")}>
                <div className="coverWidgetGradient"></div>
                <div className="activeWidgetElement">
                    {widgetMap[props.activeBlock.workingBlock.title]}
                </div>
            </div>
            <img className="clockBase" src={clock} alt="large black circle divided into 24 quadrants, representing a 24 hour day"></img>
        </div>
    )
}

export default ActiveWidget;